var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.get_PD_userData.portfolio_name)?_c('span',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.get_PD_userData.portfolio_name))]):_c('span',{attrs:{"id":"title"}},[_vm._v("Dashboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }